import { type SubmitFunction } from '@remix-run/react'
import { type REGULAR_FORM } from '#app/constants/forms.ts'
import { type RegularState } from '#types/form/wizard.ts'

import { handleSubmitRegularForm } from './handleSubmitRegularForm.ts'
import { setNextQuestionDispatcher } from './setNextQuestionDispatcher.ts'

interface HandleRegularStateParams<T> {
	currentFormContext: { [key: string]: string }
	CSRFToken: string
	actionRoute: string
	entireGlobalState: RegularState<T>
	dispatch: Function
	submit: SubmitFunction
	currentStepProps: any
}

export function handleRegularState<T>({
	currentFormContext,
	CSRFToken,
	actionRoute,
	currentStepProps,
	entireGlobalState,
	dispatch,
	submit,
}: HandleRegularStateParams<T>) {
	const { type } = entireGlobalState

	const { id, fieldKey, hasBackendCall, isLastStep, backendAction } =
		currentStepProps

	if (!isLastStep && !hasBackendCall) {
		setNextQuestionDispatcher({
			type: type as typeof REGULAR_FORM,
			currentFormContext,
			fieldKey,
			isLastStep,
			dispatch: dispatch as any,
		})
	} else {
		handleSubmitRegularForm({
			fieldKey,
			id,
			CSRFToken,
			backendAction,
			currentFormContext,
			entireGlobalState,
			actionRoute,
			submit,
		})
	}
}
